import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// 保存時に正式発番する。pending = { template_id, values }
export async function finalizePendingSku(pending) {
  const r = await axios.post(`${API}/sku/issue`, pending, { withCredentials: true });
  return r.data.sku;
}

export const SKU_PENDING_NOTE = '品番は保存時に正式発番されます。キャンセル時は消費されません。';
